import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { OneCPayloadT } from '../types/onec.types'
import {
    OneCResponseT,
    OneCGetParamsT,
    ResendDispatcher,
    OneCDeliveryResponse,
    OneCDeliveryGetParams,
    ResendDelivery,
    SdtOrdersResponse,
    SdtOrdersParams,
    SdtOrdersResendParams,
    OneCGetTripsParams,
    OneCTripsResponse,
} from '@/core/types/one_c.types'

export class OneCRepository {
    restoreOrders(onec_payload: OneCPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/admin/orders/resend-onec', onec_payload)
    }

    resendTrips(onec_payload: OneCPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/tms/api/trips/resend-to-onec', onec_payload)
    }

    getList(params: OneCGetParamsT): Promise<AxiosResponse<OneCResponseT>> {
        return http.get('/cabinet/api/v2/admin/orders', { params })
    }

    getTrips(params: OneCGetTripsParams): Promise<AxiosResponse<OneCTripsResponse>> {
        return http.get('/tms/api/trips', { params })
    }

    getDeliveryList(params: OneCDeliveryGetParams): Promise<AxiosResponse<OneCDeliveryResponse>> {
        return http.get('/dispatcher/api/deliveries-onec', { params })
    }

    getSdtOrders(params: SdtOrdersParams): Promise<AxiosResponse<SdtOrdersResponse>> {
        return http.get('/cabinet/api/sdt-orders', { params })
    }

    resend(orderId: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/v2/orders/${orderId}/resend`, { orderId })
    }

    resendDeliveryById(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/dispatcher/api/deliveries-onec/${id}`, { id })
    }

    resendDispatcher(payload: ResendDispatcher): Promise<AxiosResponse<void>> {
        return http.put('/cabinet/api/admin/orders/resend-dispatcher', payload)
    }

    resendDelivery(payload: ResendDelivery): Promise<AxiosResponse<void>> {
        return http.post('/dispatcher/api/deliveries-onec', payload)
    }

    resendSdt(payload: SdtOrdersResendParams): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/sdt-orders/mass-create', payload)
    }

    resendSdtOrder(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/sdt-orders/${id}/create`, { id })
    }

    syncOnec(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/cabinet/api/sdt-orders/sync-statuses', form_data)
    }
}
